//#region src/components/DatePicker/utils/calendar.ts
var e = 40, t = 280;
//#endregion
export { t as CAL_WIDTH, e as CELL };
